/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AddContactDto
 */
export interface AddContactDto {
    /**
     * Contact user ID (patient or provider ID)
     * @type {string}
     * @memberof AddContactDto
     */
    contactId: string;
    /**
     * Type of contact (patient or provider)
     * @type {string}
     * @memberof AddContactDto
     */
    contactType: AddContactDtoContactTypeEnum;
}


/**
 * @export
 */
export const AddContactDtoContactTypeEnum = {
    Patient: 'patient',
    Provider: 'provider'
} as const;
export type AddContactDtoContactTypeEnum = typeof AddContactDtoContactTypeEnum[keyof typeof AddContactDtoContactTypeEnum];


/**
 * Check if a given object implements the AddContactDto interface.
 */
export function instanceOfAddContactDto(value: object): value is AddContactDto {
    if (!('contactId' in value) || value['contactId'] === undefined) return false;
    if (!('contactType' in value) || value['contactType'] === undefined) return false;
    return true;
}

export function AddContactDtoFromJSON(json: any): AddContactDto {
    return AddContactDtoFromJSONTyped(json, false);
}

export function AddContactDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): AddContactDto {
    if (json == null) {
        return json;
    }
    return {
        
        'contactId': json['contactId'],
        'contactType': json['contactType'],
    };
}

export function AddContactDtoToJSON(json: any): AddContactDto {
    return AddContactDtoToJSONTyped(json, false);
}

export function AddContactDtoToJSONTyped(value?: AddContactDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'contactId': value['contactId'],
        'contactType': value['contactType'],
    };
}

